
const SITE_WIDGET_HOST = 'https://d38wtz2u937gvx.cloudfront.net';  // Checkout Django page server 'http://192.168.1.164:8000'
const SITE_WIDGET_MODAL_PATH = '/site-widget/modal/';
const MERCHANT_ID = 797;

function initializeSiteWidget() {
  var params = {mid: MERCHANT_ID};

  // Toggle tooltip visibility based on widget state
  var modalCheckbox = document.getElementById('siteWidgetModalChk');
  var tooltipModal = document.getElementById('tooltip-modal');
  if (modalCheckbox.checked) {
    tooltipModal.style.visibility = 'hidden';
  } else {
    tooltipModal.style.visibility = 'visible';
  }

  var iframeUrl = new URL(SITE_WIDGET_MODAL_PATH, SITE_WIDGET_HOST);
  Object.keys(params).forEach(key => {
    iframeUrl.searchParams.set(key.toLowerCase(), params[key]);
  });
  // Load only if iframe is not already present
  var iframe = document.querySelector('#siteWidgetContainer iframe');
  if (iframe == null) {
    document.getElementById('siteWidgetContainer').innerHTML += `<iframe title="Pragma-site-widget" sandbox="allow-scripts allow-popups allow-same-origin allow-forms allow-popups-to-escape-sandbox" src="${iframeUrl.href}" onload="siteWidgetLoaded()" class="d-none"></iframe>`;
  }else{
    iframe.classList.remove('d-none');
    if(document.querySelector('#siteWidgetContainer .site-widget-loader')){
       document.querySelector('#siteWidgetContainer .site-widget-loader').remove(); 
    }
  };
};

function siteWidgetLoaded() {
  var iframe = document.querySelector('#siteWidgetContainer iframe');
  let dispalySiteWidget = []
  if (dispalySiteWidget.length > 0 && dispalySiteWidget.some(value => window.location.href.includes(value))) {
    document.getElementById('siteWidgetTogglerBtn').style.visibility = 'hidden';
    document.getElementById('tooltip-modal').style.visibility = 'hidden';
  } else {
    document.getElementById('siteWidgetTogglerBtn').style.visibility = 'visible';
    if (document.getElementById('siteWidgetModalChk').checked) {
      document.getElementById('tooltip-modal').style.visibility = 'hidden';
    } else {
      document.getElementById('tooltip-modal').style.visibility = 'visible';
    }
  }
  // document.getElementById('siteWidgetTogglerBtn').style.visibility = 'visible';
  if(document.querySelector('#siteWidgetContainer .site-widget-loader')){
    document.querySelector('#siteWidgetContainer .site-widget-loader').remove(); 
  }
  if (document.getElementById('siteWidgetModalChk').checked == true){
    iframe.classList.remove('d-none');
  }
};

initializeSiteWidget();

document.addEventListener('DOMContentLoaded', () => {
  let loopCount = 0; // Counter to track loops
  const maxLoops = 0; // Maximum number of loops

  const tooltipModal = document.getElementById('tooltip-modal');
  const sentences = ['Whatsapp us'];

  let sentenceIndex = 0;
  let charIndex = 0;
  let effectType = "typing";

  // function moveToNextSentence(effectFunction) {
  //   sentenceIndex = (sentenceIndex + 1) % sentences.length;
  
  //   // Check if a full loop is completed
  //   if (sentenceIndex === 0) {
  //     loopCount++;
  //   }
  
  //   // Stop animation after reaching max loops
  //   if(maxLoops === 0){
  //     effectFunction();
  //     return
  //   }

  //   if (loopCount >= maxLoops) {
  //     console.log("Animation completed after 2 loops.");
  //     return;
  //   }
  
  //   // Continue with the current effect
  //   effectFunction();
  // }

  function typeSentence() {
    const currentSentence = sentences[sentenceIndex];
    if (charIndex < currentSentence.length) {
      tooltipModal.textContent += currentSentence[charIndex];
      charIndex++;
      setTimeout(typeSentence, 100); // Simulate typing speed
    } else {
      setTimeout(clearText, 2000); // Wait 2 seconds before clearing
    }
  }

  // function typeSentence() {
  //   let charIndex = 0;
  //   const currentSentence = sentences[sentenceIndex];
  
  //   function typeChar() {
  //     if (charIndex < currentSentence.length) {
  //       tooltipModal.textContent += currentSentence[charIndex];
  //       charIndex++;
  //       setTimeout(typeChar, 100); // Typing speed
  //     } else {
  //       moveToNextSentence(typeSentence);
  //     }
  //   }
  
  //   typeChar();
  // }

  function clearText() {
    if (charIndex > 0) {
      tooltipModal.textContent = tooltipModal.textContent.slice(0, -1);
      charIndex--;
      setTimeout(clearText, 50); // Simulate deleting speed
    } else {
      sentenceIndex = (sentenceIndex + 1) % sentences.length;
      typeSentence();
    }
  }

  function showPopup() {
    tooltipModal.style.opacity = "1"; // Show the popup
    tooltipModal.textContent = sentences[sentenceIndex];
    sentenceIndex = (sentenceIndex + 1) % sentences.length;

    setTimeout(() => {
      tooltipModal.style.opacity = "0"; // Hide the popup after 2 seconds
      if (effectType === "fade-out") {
        setTimeout(showPopup(), 1000); // Add a delay before showing the next popup
      }
    }, 2000);
  }

  function changeSentence() {
    tooltipModal.textContent = sentences[sentenceIndex];
    sentenceIndex = (sentenceIndex + 1) % sentences.length;
    setTimeout(() => {
      if (effectType === "normal") {
        changeSentence();
      }
    }, 2000); // Normal sentence change interval
  }

  // Show popup with animation
  function showAnimatedPopup() {
    tooltipModal.classList.add('show'); // Apply animation class
    tooltipModal.textContent = sentences[sentenceIndex]; // Update content

    // Move to the next sentence after a delay
    sentenceIndex = (sentenceIndex + 1) % sentences.length;

    setTimeout(() => {
      tooltipModal.classList.remove('show'); // Remove animation class
      if (effectType === "animated-popup") {
        setTimeout(showAnimatedPopup(), 1000)
      }
    }, 2000); // Keep popup visible for 2 seconds
  }
  
  // Start the effect based on the setting
  function startEffect() {
    tooltipModal.textContent = ""; // Reset content
    tooltipModal.style.opacity = "1"; // Reset visibility
    tooltipModal.classList.remove('show'); // Reset animation state

    if (effectType === "typing") {
      typeSentence();
    } else if (effectType === "fade-out") {
      showPopup();
    } else if (effectType === "animated-popup") {
      showAnimatedPopup();
    } else {
      changeSentence();
    }
  }

  startEffect();
});

